import React from 'react';

export const IconExecutor = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.5001 10L5.52265 16.9775C5.19113 17.309 4.74149 17.4953 4.27265 17.4953C3.80381 17.4953 3.35417 17.309 3.02265 16.9775C2.69113 16.646 2.50488 16.1963 2.50488 15.7275C2.50488 15.2587 2.69113 14.809 3.02265 14.4775L10.0001 7.5M15.0001 12.5L18.3335 9.16667"
                stroke="#252733"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9169 9.58412L16.3219 7.98912C16.0093 7.67663 15.8337 7.25278 15.8336 6.81079V5.83412L13.9502 3.95079C13.0207 3.02177 11.7628 2.49609 10.4486 2.48745L7.50024 2.46745L8.26691 3.15079C8.81146 3.63361 9.24749 4.22637 9.54626 4.88999C9.84503 5.55361 9.99976 6.27301 10.0002 7.00079V8.33412L11.6669 10.0008H12.6436C13.0856 10.0009 13.5094 10.1765 13.8219 10.4891L15.4169 12.0841"
                stroke="#252733"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
